// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.


export const environment = {
  production: false,
  API_ENDPOINT:"",
  ENDPOINT:"http://44.207.111.67:3001/",
  EDITENDPOINT :"https://hyperdrive-api.ldttechnology.com/",
  // EDITENDPOINT :"http://192.168.1.7:3001/",
  // EDITENDPOINT :"http://122.176.50.200:3010/",
};
